module.exports = __webpack_public_path__ + "static/faq-3f747d0b63b6b622181bef4684be0ed7.jpg";